// Store reinitialization
export const REINIT_STATE = 'REINIT_STATE';

// Persistance and versionning
export const STORE_PERSISTOR = 'STORE_PERSISTOR';
export const UPDATE_PERSIST_STORE_VERSION = 'UPDATE_PERSIST_STORE_VERSION';

// Locale
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

// Loading generic action
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const HIDE_LOADING_REINIT = 'HIDE_LOADING_REINIT';

// Notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

// Dialogs
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const FLUSH_DIALOG = 'FLUSH_DIALOG';

// WebSocket
export const WS_CONNECT = 'WS_CONNECT';
export const WS_DISCONNECT = 'WS_DISCONNECT';
export const WS_OPEN = 'WS_OPEN';
export const WS_CLOSE = 'WS_CLOSE';
export const WS_JOIN_TOPIC = 'WS_JOIN_TOPIC';
export const WS_LEAVE_TOPIC = 'WS_LEAVE_TOPIC';
export const WS_REPLY = 'WS_REPLY';
export const WS_SEND_MESSAGE = 'WS_SEND_MESSAGE';
export const WS_SEND_SUBSCRIPTION = 'WS_SEND_SUBSCRIPTION';
export const WS_RECEIVED_ASYNC_RESULT = 'WS_RECEIVED_ASYNC_RESULT';
export const WS_RECEIVED_ERROR = 'WS_RECEIVED_ERROR';
export const WS_RECEIVED_OPERATION = 'WS_RECEIVED_OPERATION';
export const WS_RECEIVED_SUBSCRIPTION_DATA = 'WS_RECEIVED_SUBSCRIPTION_DATA';

// Auth
export const REINIT_AUTH = 'REINIT_AUTH';
export const POST_LOGIN = 'POST_LOGIN';
export const POST_LOGIN_BY_MAGIC_LINK = 'POST_LOGIN_BY_MAGIC_LINK';
export const POST_LOGOUT = 'POST_LOGOUT';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const POST_RECOVER_PASSWORD = 'POST_RECOVER_PASSWORD';
export const GET_RECOVER_PASSWORD_LINK = 'GET_RECOVER_PASSWORD_LINK';
export const UPDATE_RECOVER_PASSWORD_LINK = 'UPDATE_RECOVER_PASSWORD_LINK';

// Me
export const GET_ME = 'GET_ME';
export const UPDATE_ME = 'UPDATE_ME';

// List
export const REFRESH_LIST = 'REFRESH_LIST';
export const REFRESH_LIST_REINIT = 'REFRESH_LIST_REINIT';
export const UPDATE_LIST_LAST_PARAMS = 'UPDATE_LIST_LAST_PARAMS';

// Async operations / registrations
export const REGISTER_ASYNC_OPERATION = 'REGISTER_ASYNC_OPERATION';
export const PURGE_ASYNC_OPERATIONS = 'PURGE_ASYNC_OPERATIONS';
export const TIMEOUT_ASYNC_OPERATION = 'TIMEOUT_ASYNC_OPERATION';
export const REGISTER_DEVICE_CMD = 'REGISTER_DEVICE_CMD';
export const REGISTER_INSTALLATION_TRIGGER = 'REGISTER_INSTALLATION_TRIGGER';

// AutoComplete
export const GET_INSTALLATIONS_AUTOCOMPLETE = 'GET_INSTALLATIONS_AUTOCOMPLETE';
export const GET_INSTALLATIONS_AUTOCOMPLETE_SUCCESS = 'GET_INSTALLATIONS_AUTOCOMPLETE_SUCCESS';
export const GET_INSTALLATIONS_AUTOCOMPLETE_ERROR = 'GET_INSTALLATIONS_AUTOCOMPLETE_ERROR';
export const GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE = 'GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE';
export const GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_SUCCESS = 'GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_SUCCESS';
export const GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_ERROR = 'GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_ERROR';
export const GET_DEVICES_AUTOCOMPLETE = 'GET_DEVICES_AUTOCOMPLETE';
export const GET_DEVICES_AUTOCOMPLETE_SUCCESS = 'GET_DEVICES_AUTOCOMPLETE_SUCCESS';
export const GET_DEVICES_AUTOCOMPLETE_ERROR = 'GET_DEVICES_AUTOCOMPLETE_ERROR';
export const GET_SIMCARDS_AUTOCOMPLETE = 'GET_SIMCARDS_AUTOCOMPLETE';
export const GET_SIMCARDS_AUTOCOMPLETE_SUCCESS = 'GET_SIMCARDS_AUTOCOMPLETE_SUCCESS';
export const GET_SIMCARDS_AUTOCOMPLETE_ERROR = 'GET_SIMCARDS_AUTOCOMPLETE_ERROR';
export const GET_DISTRIBUTIONS_AUTOCOMPLETE = 'GET_DISTRIBUTIONS_AUTOCOMPLETE';
export const GET_DISTRIBUTIONS_AUTOCOMPLETE_SUCCESS = 'GET_DISTRIBUTIONS_AUTOCOMPLETE_SUCCESS';
export const GET_DISTRIBUTIONS_AUTOCOMPLETE_ERROR = 'GET_DISTRIBUTIONS_AUTOCOMPLETE_ERROR';
export const GET_PROFILES_AUTOCOMPLETE = 'GET_PROFILES_AUTOCOMPLETE';
export const GET_PROFILES_AUTOCOMPLETE_SUCCESS = 'GET_PROFILES_AUTOCOMPLETE_SUCCESS';
export const GET_PROFILES_AUTOCOMPLETE_ERROR = 'GET_PROFILES_AUTOCOMPLETE_ERROR';

// List filter
export const GET_INSTALLATION_LF = 'GET_INSTALLATION_LF';
export const GET_INSTALLATION_LF_SUCCESS = 'GET_INSTALLATION_LF_SUCCESS';
export const GET_INSTALLATION_CUSTOMER_LF = 'GET_INSTALLATION_CUSTOMER_LF';
export const GET_INSTALLATION_CUSTOMER_LF_SUCCESS = 'GET_INSTALLATION_CUSTOMER_LF_SUCCESS';
export const GET_DEVICE_LF = 'GET_DEVICE_LF';
export const GET_DEVICE_LF_SUCCESS = 'GET_DEVICE_LF_SUCCESS';
export const GET_SIMCARD_LF = 'GET_SIMCARD_LF';
export const GET_SIMCARD_LF_SUCCESS = 'GET_SIMCARD_LF_SUCCESS';
export const GET_DISTRIBUTION_LF = 'GET_DISTRIBUTION_LF';
export const GET_DISTRIBUTION_LF_SUCCESS = 'GET_DISTRIBUTION_LF_SUCCESS';
export const GET_PROFILE_LF = 'GET_PROFILE_LF';
export const GET_PROFILE_LF_SUCCESS = 'GET_PROFILE_LF_SUCCESS';

// Operators
export const GET_OPERATORS = 'GET_OPERATORS';
export const GET_OPERATORS_SUCCESS = 'GET_OPERATORS_SUCCESS';
export const GET_OPERATORS_ERROR = 'GET_OPERATORS_ERROR';

// Equipments
export const GET_EQUIPMENTS_LIST = 'GET_EQUIPMENTS_LIST';
export const GET_EQUIPMENTS_LIST_SUCCESS = 'GET_EQUIPMENTS_LIST_SUCCESS';
export const GET_EQUIPMENTS_LIST_ERROR = 'GET_EQUIPMENTS_LIST_ERROR';

// Device events
export const ADD_DEVICE_EVENT = 'ADD_DEVICE_EVENT';
export const UPDATE_DEVICE_EVENT_STATUS = 'UPDATE_DEVICE_EVENT_STATUS';

// Device models
export const GET_DEVICE_MODELS = 'GET_DEVICE_MODELS';
export const GET_DEVICE_MODELS_SUCCESS = 'GET_DEVICE_MODELS_SUCCESS';
export const GET_DEVICE_MODELS_ERROR = 'GET_DEVICE_MODELS_ERROR';

// Devices
// Main
export const GET_DEVICES_LIST = 'GET_DEVICES_LIST';
export const GET_DEVICES_LIST_SUCCESS = 'GET_DEVICES_LIST_SUCCESS';
export const GET_DEVICES_LIST_ERROR = 'GET_DEVICES_LIST_ERROR';
export const GET_DEVICE = 'GET_DEVICE';
export const GET_DEVICE_SUCCESS = 'GET_DEVICE_SUCCESS';
export const GET_DEVICE_ERROR = 'GET_DEVICE_ERROR';
export const GET_DEVICE_INFO = 'GET_DEVICE_INFO';
export const GET_DEVICE_INFO_SUCCESS = 'GET_DEVICE_INFO_SUCCESS';
export const GET_DEVICE_INFO_ERROR = 'GET_DEVICE_INFO_ERROR';
export const GET_DEVICE_SYNC = 'GET_DEVICE_SYNC';
export const GET_DEVICE_SYNC_SUCCESS = 'GET_DEVICE_SYNC_SUCCESS';
export const GET_DEVICE_SYNC_ERROR = 'GET_DEVICE_SYNC_ERROR';
export const GET_DEVICE_INSTALLATION = 'GET_DEVICE_INSTALLATION';
export const GET_DEVICE_INSTALLATION_SUCCESS = 'GET_DEVICE_INSTALLATION_SUCCESS';
export const GET_DEVICE_INSTALLATION_ERROR = 'GET_DEVICE_INSTALLATION_ERROR';
export const SEND_CMD_DEVICE = 'SEND_CMD_DEVICE';
export const SEND_CMD_DEVICE_SUCCESS = 'SEND_CMD_DEVICE_SUCCESS';
export const SEND_CMD_DEVICE_ERROR = 'SEND_CMD_DEVICE_ERROR';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const DELETE_DEVICE_SUCCESS = 'DELETE_DEVICE_SUCCESS';
export const DELETE_DEVICE_ERROR = 'DELETE_DEVICE_ERROR';
export const UPDATE_DEVICE = 'UPDATE_DEVICE';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const UPDATE_DEVICE_ERROR = 'UPDATE_DEVICE_ERROR';
export const SET_DEVICE_PERMISSIONS = 'SET_DEVICE_PERMISSIONS';
// SMS
export const SEND_DEVICE_SMS = 'SEND_DEVICE_SMS';
export const SEND_DEVICE_SMS_SUCCESS = 'SEND_DEVICE_SMS_SUCCESS';
export const SEND_DEVICE_SMS_ERROR = 'SEND_DEVICE_SMS_ERROR';
export const GET_DEVICE_SMS_HISTORY = 'GET_DEVICE_SMS_HISTORY';
export const GET_DEVICE_SMS_HISTORY_SUCCESS = 'GET_DEVICE_SMS_HISTORY_SUCCESS';
export const GET_DEVICE_SMS_HISTORY_ERROR = 'GET_DEVICE_SMS_HISTORY_ERROR';
export const GET_DEVICE_SMS_STATUS = 'GET_DEVICE_SMS_STATUS';
export const GET_DEVICE_SMS_STATUS_SUCCESS = 'GET_DEVICE_SMS_STATUS_SUCCESS';
export const GET_DEVICE_SMS_STATUS_ERROR = 'GET_DEVICE_SMS_STATUS_ERROR';
// Simcard
export const LINK_DEVICE_SIMCARD = 'LINK_DEVICE_SIMCARD';
export const LINK_DEVICE_SIMCARD_SUCCESS = 'LINK_DEVICE_SIMCARD_SUCCESS';
export const LINK_DEVICE_SIMCARD_ERROR = 'LINK_DEVICE_SIMCARD_ERROR';
export const UNLINK_DEVICE_SIMCARD = 'UNLINK_DEVICE_SIMCARD';
export const UNLINK_DEVICE_SIMCARD_SUCCESS = 'UNLINK_DEVICE_SIMCARD_SUCCESS';
export const UNLINK_DEVICE_SIMCARD_ERROR = 'UNLINK_DEVICE_SIMCARD_ERROR';
// Config
export const UPDATE_DEVICE_CONFIG = 'UPDATE_DEVICE_CONFIG';
export const UPDATE_DEVICE_CONFIG_SUCCESS = 'UPDATE_DEVICE_CONFIG_SUCCESS';
export const UPDATE_DEVICE_CONFIG_ERROR = 'UPDATE_DEVICE_CONFIG_ERROR';
// Logs
export const GET_DEVICE_LOGS_LIST = 'GET_DEVICE_LOGS_LIST';
export const GET_DEVICE_LOGS_LIST_SUCCESS = 'GET_DEVICE_LOGS_LIST_SUCCESS';
export const GET_DEVICE_LOGS_LIST_ERROR = 'GET_DEVICE_LOGS_LIST_ERROR';
// Distributions
export const GET_DEVICE_DISTRIBUTIONS_HISTORY = 'GET_DEVICE_DISTRIBUTIONS_HISTORY';
export const GET_DEVICE_DISTRIBUTIONS_HISTORY_SUCCESS = 'GET_DEVICE_DISTRIBUTIONS_HISTORY_SUCCESS';
export const GET_DEVICE_DISTRIBUTIONS_HISTORY_ERROR = 'GET_DEVICE_DISTRIBUTIONS_HISTORY_ERROR';

// Device slaves
export const GET_DEVICE_SLAVES_LIST = 'GET_DEVICE_SLAVES_LIST';
export const GET_DEVICE_SLAVES_LIST_SUCCESS = 'GET_DEVICE_SLAVES_LIST_SUCCESS';
export const GET_DEVICE_SLAVES_LIST_ERROR = 'GET_DEVICE_SLAVES_LIST_ERROR';
export const GET_DEVICE_SLAVE = 'GET_DEVICE_SLAVE';
export const GET_DEVICE_SLAVE_SUCCESS = 'GET_DEVICE_SLAVE_SUCCESS';
export const GET_DEVICE_SLAVE_ERROR = 'GET_DEVICE_SLAVE_ERROR';
export const DELETE_DEVICE_SLAVE = 'DELETE_DEVICE_SLAVE';
export const DELETE_DEVICE_SLAVE_SUCCESS = 'DELETE_DEVICE_SLAVE_SUCCESS';
export const DELETE_DEVICE_SLAVE_ERROR = 'DELETE_DEVICE_SLAVE_ERROR';
export const UPDATE_DEVICE_SLAVE = 'UPDATE_DEVICE_SLAVE';
export const UPDATE_DEVICE_SLAVE_SUCCESS = 'UPDATE_DEVICE_SLAVE_SUCCESS';
export const UPDATE_DEVICE_SLAVE_ERROR = 'UPDATE_DEVICE_SLAVE_ERROR';

// Installations
// Cache
export const RESET_INSTALLATION_CACHE = 'RESET_INSTALLATION_CACHE';
// Main
export const GET_INSTALLATIONS_LIST = 'GET_INSTALLATIONS_LIST';
export const GET_INSTALLATIONS_LIST_SUCCESS = 'GET_INSTALLATIONS_LIST_SUCCESS';
export const GET_INSTALLATIONS_LIST_ERROR = 'GET_INSTALLATIONS_LIST_ERROR';
export const ADD_INSTALLATION = 'ADD_INSTALLATION';
export const ADD_INSTALLATION_SUCCESS = 'ADD_INSTALLATION_SUCCESS';
export const ADD_INSTALLATION_ERROR = 'ADD_INSTALLATION_ERROR';
export const GET_INSTALLATION = 'GET_INSTALLATION';
export const GET_INSTALLATION_SUCCESS = 'GET_INSTALLATION_SUCCESS';
export const GET_INSTALLATION_ERROR = 'GET_INSTALLATION_ERROR';
export const SET_INSTALLATION_PERMISSIONS = 'SET_INSTALLATION_PERMISSIONS';
export const UPDATE_INSTALLATION = 'UPDATE_INSTALLATION';
export const UPDATE_INSTALLATION_SUCCESS = 'UPDATE_INSTALLATION_SUCCESS';
export const UPDATE_INSTALLATION_ERROR = 'UPDATE_INSTALLATION_ERROR';
export const DELETE_INSTALLATION = 'DELETE_INSTALLATION';
export const DELETE_INSTALLATION_SUCCESS = 'DELETE_INSTALLATION_SUCCESS';
export const DELETE_INSTALLATION_ERROR = 'DELETE_INSTALLATION_ERROR';
// Entities
export const GET_INSTALLATION_ENTITIES = 'GET_INSTALLATION_ENTITIES';
export const GET_INSTALLATION_ENTITIES_SUCCESS = 'GET_INSTALLATION_ENTITIES_SUCCESS';
export const GET_INSTALLATION_ENTITIES_ERROR = 'GET_INSTALLATION_ENTITIES_ERROR';
export const ADD_INSTALLATION_ENTITY = 'ADD_INSTALLATION_ENTITY';
export const ADD_INSTALLATION_ENTITY_SUCCESS = 'ADD_INSTALLATION_ENTITY_SUCCESS';
export const ADD_INSTALLATION_ENTITY_ERROR = 'ADD_INSTALLATION_ENTITY_ERROR';
export const UPDATE_INSTALLATION_ENTITY = 'UPDATE_INSTALLATION_ENTITY';
export const UPDATE_INSTALLATION_ENTITY_SUCCESS = 'UPDATE_INSTALLATION_ENTITY_SUCCESS';
export const UPDATE_INSTALLATION_ENTITY_ERROR = 'UPDATE_INSTALLATION_ENTITY_ERROR';
export const DELETE_INSTALLATION_ENTITY = 'DELETE_INSTALLATION_ENTITY';
export const DELETE_INSTALLATION_ENTITY_SUCCESS = 'DELETE_INSTALLATION_ENTITY_SUCCESS';
export const DELETE_INSTALLATION_ENTITY_ERROR = 'DELETE_INSTALLATION_ENTITY_ERROR';
// Doors
export const GET_INSTALLATION_DOORS = 'GET_INSTALLATION_DOORS';
export const GET_INSTALLATION_DOORS_SUCCESS = 'GET_INSTALLATION_DOORS_SUCCESS';
export const GET_INSTALLATION_DOORS_ERROR = 'GET_INSTALLATION_DOORS_ERROR';
export const ADD_INSTALLATION_DOOR = 'ADD_INSTALLATION_DOOR';
export const ADD_INSTALLATION_DOOR_SUCCESS = 'ADD_INSTALLATION_DOOR_SUCCESS';
export const ADD_INSTALLATION_DOOR_ERROR = 'ADD_INSTALLATION_DOOR_ERROR';
export const DELETE_INSTALLATION_DOOR = 'DELETE_INSTALLATION_DOOR';
export const DELETE_INSTALLATION_DOOR_SUCCESS = 'DELETE_INSTALLATION_DOOR_SUCCESS';
export const DELETE_INSTALLATION_DOOR_ERROR = 'DELETE_INSTALLATION_DOOR_ERROR';
export const GET_INSTALLATION_DOOR = 'GET_INSTALLATION_DOOR';
export const GET_INSTALLATION_DOOR_SUCCESS = 'GET_INSTALLATION_DOOR_SUCCESS';
export const GET_INSTALLATION_DOOR_ERROR = 'GET_INSTALLATION_DOOR_ERROR';
export const UPDATE_INSTALLATION_DOOR = 'UPDATE_INSTALLATION_DOOR';
export const UPDATE_INSTALLATION_DOOR_SUCCESS = 'UPDATE_INSTALLATION_DOOR_SUCCESS';
export const UPDATE_INSTALLATION_DOOR_ERROR = 'UPDATE_INSTALLATION_DOOR_ERROR';
// Sources
export const GET_INSTALLATION_SOURCES = 'GET_INSTALLATION_SOURCES';
export const GET_INSTALLATION_SOURCES_SUCCESS = 'GET_INSTALLATION_SOURCES_SUCCESS';
export const GET_INSTALLATION_SOURCES_ERROR = 'GET_INSTALLATION_SOURCES_ERROR';
export const ADD_INSTALLATION_SOURCE = 'ADD_INSTALLATION_SOURCE';
export const ADD_INSTALLATION_SOURCE_SUCCESS = 'ADD_INSTALLATION_SOURCE_SUCCESS';
export const ADD_INSTALLATION_SOURCE_ERROR = 'ADD_INSTALLATION_SOURCE_ERROR';
export const DELETE_INSTALLATION_SOURCE = 'DELETE_INSTALLATION_SOURCE';
export const DELETE_INSTALLATION_SOURCE_SUCCESS = 'DELETE_INSTALLATION_SOURCE_SUCCESS';
export const DELETE_INSTALLATION_SOURCE_ERROR = 'DELETE_INSTALLATION_SOURCE_ERROR';
export const GET_INSTALLATION_SOURCE = 'GET_INSTALLATION_SOURCE';
export const GET_INSTALLATION_SOURCE_SUCCESS = 'GET_INSTALLATION_SOURCE_SUCCESS';
export const GET_INSTALLATION_SOURCE_ERROR = 'GET_INSTALLATION_SOURCE_ERROR';
export const UPDATE_INSTALLATION_SOURCE = 'UPDATE_INSTALLATION_SOURCE';
export const UPDATE_INSTALLATION_SOURCE_SUCCESS = 'UPDATE_INSTALLATION_SOURCE_SUCCESS';
export const UPDATE_INSTALLATION_SOURCE_ERROR = 'UPDATE_INSTALLATION_SOURCE_ERROR';
// Devices
export const GET_INSTALLATION_DEVICES = 'GET_INSTALLATION_DEVICES';
export const GET_INSTALLATION_DEVICES_SUCCESS = 'GET_INSTALLATION_DEVICES_SUCCESS';
export const GET_INSTALLATION_DEVICES_ERROR = 'GET_INSTALLATION_DEVICES_ERROR';
export const ADD_INSTALLATION_DEVICE = 'ADD_INSTALLATION_DEVICE';
export const ADD_INSTALLATION_DEVICE_SUCCESS = 'ADD_INSTALLATION_DEVICE_SUCCESS';
export const ADD_INSTALLATION_DEVICE_ERROR = 'ADD_INSTALLATION_DEVICE_ERROR';
export const DELETE_INSTALLATION_DEVICE = 'DELETE_INSTALLATION_DEVICE';
export const DELETE_INSTALLATION_DEVICE_SUCCESS = 'DELETE_INSTALLATION_DEVICE_SUCCESS';
export const DELETE_INSTALLATION_DEVICE_ERROR = 'DELETE_INSTALLATION_DEVICE_ERROR';
export const GET_INSTALLATION_DEVICE = 'GET_INSTALLATION_DEVICE';
export const GET_INSTALLATION_DEVICE_SUCCESS = 'GET_INSTALLATION_DEVICE_SUCCESS';
export const GET_INSTALLATION_DEVICE_ERROR = 'GET_INSTALLATION_DEVICE_ERROR';
export const UPDATE_INSTALLATION_DEVICE = 'UPDATE_INSTALLATION_DEVICE';
export const UPDATE_INSTALLATION_DEVICE_SUCCESS = 'UPDATE_INSTALLATION_DEVICE_SUCCESS';
export const UPDATE_INSTALLATION_DEVICE_ERROR = 'UPDATE_INSTALLATION_DEVICE_ERROR';
export const REPLACE_INSTALLATION_DEVICE = 'REPLACE_INSTALLATION_DEVICE';
export const REPLACE_INSTALLATION_DEVICE_SUCCESS = 'REPLACE_INSTALLATION_DEVICE_SUCCESS';
export const REPLACE_INSTALLATION_DEVICE_ERROR = 'REPLACE_INSTALLATION_DEVICE_ERROR';
// Device slaves
export const UPDATE_INSTALLATION_DEVICE_SLAVE = 'UPDATE_INSTALLATION_DEVICE_SLAVE';
export const UPDATE_INSTALLATION_DEVICE_SLAVE_SUCCESS = 'UPDATE_INSTALLATION_DEVICE_SLAVE_SUCCESS';
export const UPDATE_INSTALLATION_DEVICE_SLAVE_ERROR = 'UPDATE_INSTALLATION_DEVICE_SLAVE_ERROR';
export const GET_INSTALLATION_DEVICE_SLAVE = 'GET_INSTALLATION_DEVICE_SLAVE';
export const GET_INSTALLATION_DEVICE_SLAVE_SUCCESS = 'GET_INSTALLATION_DEVICE_SLAVE_SUCCESS';
export const GET_INSTALLATION_DEVICE_SLAVE_ERROR = 'GET_INSTALLATION_DEVICE_SLAVE_ERROR';
export const ADD_INSTALLATION_DEVICE_SLAVE = 'ADD_INSTALLATION_DEVICE_SLAVE';
export const ADD_INSTALLATION_DEVICE_SLAVE_SUCCESS = 'ADD_INSTALLATION_DEVICE_SLAVE_SUCCESS';
export const ADD_INSTALLATION_DEVICE_SLAVE_ERROR = 'ADD_INSTALLATION_DEVICE_SLAVE_ERROR';
export const DELETE_INSTALLATION_DEVICE_SLAVE = 'DELETE_INSTALLATION_DEVICE_SLAVE';
export const DELETE_INSTALLATION_DEVICE_SLAVE_SUCCESS = 'DELETE_INSTALLATION_DEVICE_SLAVE_SUCCESS';
export const DELETE_INSTALLATION_DEVICE_SLAVE_ERROR = 'DELETE_INSTALLATION_DEVICE_SLAVE_ERROR';
export const REPLACE_INSTALLATION_DEVICE_SLAVE = 'REPLACE_INSTALLATION_DEVICE_SLAVE';
export const REPLACE_INSTALLATION_DEVICE_SLAVE_SUCCESS = 'REPLACE_INSTALLATION_DEVICE_SLAVE_SUCCESS';
export const REPLACE_INSTALLATION_DEVICE_SLAVE_ERROR = 'REPLACE_INSTALLATION_DEVICE_SLAVE_ERROR';
// Scenarios
export const GET_INSTALLATION_SCENARIOS = 'GET_INSTALLATION_SCENARIOS';
export const GET_INSTALLATION_SCENARIOS_SUCCESS = 'GET_INSTALLATION_SCENARIOS_SUCCESS';
export const GET_INSTALLATION_SCENARIOS_ERROR = 'GET_INSTALLATION_SCENARIOS_ERROR';
export const ADD_INSTALLATION_SCENARIO = 'ADD_INSTALLATION_SCENARIO';
export const ADD_INSTALLATION_SCENARIO_SUCCESS = 'ADD_INSTALLATION_SCENARIO_SUCCESS';
export const ADD_INSTALLATION_SCENARIO_ERROR = 'ADD_INSTALLATION_SCENARIO_ERROR';
export const DELETE_INSTALLATION_SCENARIO = 'DELETE_INSTALLATION_SCENARIO';
export const DELETE_INSTALLATION_SCENARIO_SUCCESS = 'DELETE_INSTALLATION_SCENARIO_SUCCESS';
export const DELETE_INSTALLATION_SCENARIO_ERROR = 'DELETE_INSTALLATION_SCENARIO_ERROR';
export const GET_INSTALLATION_SCENARIO = 'GET_INSTALLATION_SCENARIO';
export const GET_INSTALLATION_SCENARIO_SUCCESS = 'GET_INSTALLATION_SCENARIO_SUCCESS';
export const GET_INSTALLATION_SCENARIO_ERROR = 'GET_INSTALLATION_SCENARIO_ERROR';
export const UPDATE_INSTALLATION_SCENARIO = 'UPDATE_INSTALLATION_SCENARIO';
export const UPDATE_INSTALLATION_SCENARIO_SUCCESS = 'UPDATE_INSTALLATION_SCENARIO_SUCCESS';
export const UPDATE_INSTALLATION_SCENARIO_ERROR = 'UPDATE_INSTALLATION_SCENARIO_ERROR';
export const DUPLICATE_SCENARIO = 'DUPLICATE_SCENARIO';
export const TRIGGER_INSTALLATION_SCENARIO = 'TRIGGER_INSTALLATION_SCENARIO';
export const TRIGGER_INSTALLATION_SCENARIO_SUCCESS = 'TRIGGER_INSTALLATION_SCENARIO_SUCCESS';
export const TRIGGER_INSTALLATION_SCENARIO_ERROR = 'TRIGGER_INSTALLATION_SCENARIO_ERROR';
// Customers
export const GET_INSTALLATION_CUSTOMERS_LIST = 'GET_INSTALLATION_CUSTOMERS_LIST';
export const GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS = 'GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS';
export const GET_INSTALLATION_CUSTOMERS_LIST_ERROR = 'GET_INSTALLATION_CUSTOMERS_LIST_ERROR';
export const GET_INSTALLATION_CUSTOMER = 'GET_INSTALLATION_CUSTOMER';
export const GET_INSTALLATION_CUSTOMER_SUCCESS = 'GET_INSTALLATION_CUSTOMER_SUCCESS';
export const GET_INSTALLATION_CUSTOMER_ERROR = 'GET_INSTALLATION_CUSTOMER_ERROR';
export const ADD_INSTALLATION_CUSTOMER = 'ADD_INSTALLATION_CUSTOMER';
export const ADD_INSTALLATION_CUSTOMER_SUCCESS = 'ADD_INSTALLATION_CUSTOMER_SUCCESS';
export const ADD_INSTALLATION_CUSTOMER_ERROR = 'ADD_INSTALLATION_CUSTOMER_ERROR';
export const UPDATE_INSTALLATION_CUSTOMER = 'UPDATE_INSTALLATION_CUSTOMER';
export const UPDATE_INSTALLATION_CUSTOMER_SUCCESS = 'UPDATE_INSTALLATION_CUSTOMER_SUCCESS';
export const UPDATE_INSTALLATION_CUSTOMER_ERROR = 'UPDATE_INSTALLATION_CUSTOMER_ERROR';
export const UPDATE_INSTALLATION_CUSTOMER_STATE = 'UPDATE_INSTALLATION_CUSTOMER_STATE';
export const UPDATE_INSTALLATION_CUSTOMER_STATE_SUCCESS = 'UPDATE_INSTALLATION_CUSTOMER_STATE_SUCCESS';
export const UPDATE_INSTALLATION_CUSTOMER_STATE_ERROR = 'UPDATE_INSTALLATION_CUSTOMER_STATE_ERROR';
export const DELETE_INSTALLATION_CUSTOMER = 'DELETE_INSTALLATION_CUSTOMER';
export const DELETE_INSTALLATION_CUSTOMER_SUCCESS = 'DELETE_INSTALLATION_CUSTOMER_SUCCESS';
export const DELETE_INSTALLATION_CUSTOMER_ERROR = 'DELETE_INSTALLATION_CUSTOMER_ERROR';
export const GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE = 'GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE';
export const GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_SUCCESS = 'GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_SUCCESS';
export const GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_ERROR = 'GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_ERROR';
export const GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES = 'GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES';
export const GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_SUCCESS = 'GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_SUCCESS';
export const GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_ERROR = 'GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_ERROR';
export const EXPORT_INSTALLATION_CUSTOMERS = 'EXPORT_INSTALLATION_CUSTOMERS';
export const EXPORT_INSTALLATION_CUSTOMERS_SUCCESS = 'EXPORT_INSTALLATION_CUSTOMERS_SUCCESS';
export const EXPORT_INSTALLATION_CUSTOMERS_ERROR = 'EXPORT_INSTALLATION_CUSTOMERS_ERROR';
// Customer access ways
export const GET_INSTALLATION_CUSTOMER_ACCESSWAYS = 'GET_INSTALLATION_CUSTOMER_ACCESSWAYS';
export const GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS = 'GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS';
export const GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR = 'GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR';
export const ADD_INSTALLATION_CUSTOMER_ACCESSWAY = 'ADD_INSTALLATION_CUSTOMER_ACCESSWAY';
export const ADD_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS = 'ADD_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS';
export const ADD_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR = 'ADD_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR';
export const UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY = 'UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY';
export const UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS = 'UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS';
export const UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR = 'UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR';
export const DELETE_INSTALLATION_CUSTOMER_ACCESSWAY = 'DELETE_INSTALLATION_CUSTOMER_ACCESSWAY';
export const DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS = 'DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS';
export const DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR = 'DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR';
export const TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT = 'TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT';
export const TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS = 'TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS';
export const TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_ERROR = 'TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_ERROR';
// Plannings
export const GET_INSTALLATION_PLANNINGS = 'GET_INSTALLATION_PLANNINGS';
export const GET_INSTALLATION_PLANNINGS_SUCCESS = 'GET_INSTALLATION_PLANNINGS_SUCCESS';
export const GET_INSTALLATION_PLANNINGS_ERROR = 'GET_INSTALLATION_PLANNINGS_ERROR';
export const GET_INSTALLATION_PLANNING = 'GET_INSTALLATION_PLANNING';
export const GET_INSTALLATION_PLANNING_SUCCESS = 'GET_INSTALLATION_PLANNING_SUCCESS';
export const GET_INSTALLATION_PLANNING_ERROR = 'GET_INSTALLATION_PLANNING_ERROR';
export const ADD_INSTALLATION_PLANNING = 'ADD_INSTALLATION_PLANNING';
export const ADD_INSTALLATION_PLANNING_SUCCESS = 'ADD_INSTALLATION_PLANNING_SUCCESS';
export const ADD_INSTALLATION_PLANNING_ERROR = 'ADD_INSTALLATION_PLANNING_ERROR';
export const UPDATE_INSTALLATION_PLANNING = 'UPDATE_INSTALLATION_PLANNING';
export const UPDATE_INSTALLATION_PLANNING_SUCCESS = 'UPDATE_INSTALLATION_PLANNING_SUCCESS';
export const UPDATE_INSTALLATION_PLANNING_ERROR = 'UPDATE_INSTALLATION_PLANNING_ERROR';
export const DELETE_INSTALLATION_PLANNING = 'DELETE_INSTALLATION_PLANNING';
export const DELETE_INSTALLATION_PLANNING_SUCCESS = 'DELETE_INSTALLATION_PLANNING_SUCCESS';
export const DELETE_INSTALLATION_PLANNING_ERROR = 'DELETE_INSTALLATION_PLANNING_ERROR';
// Logs
export const GET_INSTALLATION_LOGS_LIST = 'GET_INSTALLATION_LOGS_LIST';
export const GET_INSTALLATION_LOGS_LIST_SUCCESS = 'GET_INSTALLATION_LOGS_LIST_SUCCESS';
export const GET_INSTALLATION_LOGS_LIST_ERROR = 'GET_INSTALLATION_LOGS_LIST_ERROR';
// Async operations
export const GET_INSTALLATION_ASYNC_OPERATIONS_LIST = 'GET_INSTALLATION_ASYNC_OPERATIONS_LIST';
export const GET_INSTALLATION_ASYNC_OPERATION_HISTORY = 'GET_INSTALLATION_ASYNC_OPERATION_HISTORY';

// Simcards / APNs
// Main
export const GET_SIMCARDS_LIST = 'GET_SIMCARDS_LIST';
export const GET_SIMCARDS_LIST_SUCCESS = 'GET_SIMCARDS_LIST_SUCCESS';
export const GET_SIMCARDS_LIST_ERROR = 'GET_SIMCARDS_LIST_ERROR';
export const ADD_SIMCARDS = 'ADD_SIMCARDS';
export const ADD_SIMCARDS_SUCCESS = 'ADD_SIMCARDS_SUCCESS';
export const ADD_SIMCARDS_ERROR = 'ADD_SIMCARDS_ERROR';
export const IMPORT_SIMCARDS = 'IMPORT_SIMCARDS';
export const IMPORT_SIMCARDS_SUCCESS = 'IMPORT_SIMCARDS_SUCCESS';
export const IMPORT_SIMCARDS_ERROR = 'IMPORT_SIMCARDS_ERROR';
export const GET_SIMCARD = 'GET_SIMCARD';
export const GET_SIMCARD_SUCCESS = 'GET_SIMCARD_SUCCESS';
export const GET_SIMCARD_ERROR = 'GET_SIMCARD_ERROR';
export const UPDATE_SIMCARD = 'UPDATE_SIMCARD';
export const UPDATE_SIMCARD_SUCCESS = 'UPDATE_SIMCARD_SUCCESS';
export const UPDATE_SIMCARD_ERROR = 'UPDATE_SIMCARD_ERROR';
export const DELETE_SIMCARD = 'DELETE_SIMCARD';
export const DELETE_SIMCARD_SUCCESS = 'DELETE_SIMCARD_SUCCESS';
export const DELETE_SIMCARD_ERROR = 'DELETE_SIMCARD_ERROR';
export const SYNCHRONIZE_SIMCARDS = 'SYNCHRONIZE_SIMCARDS';
export const SYNCHRONIZE_SIMCARDS_SUCCESS = 'SYNCHRONIZE_SIMCARDS_SUCCESS';
export const SYNCHRONIZE_SIMCARDS_ERROR = 'SYNCHRONIZE_SIMCARDS_ERROR';
export const ACTIVATE_SIMCARDS = 'ACTIVATE_SIMCARDS';
export const ACTIVATE_SIMCARDS_SUCCESS = 'ACTIVATE_SIMCARDS_SUCCESS';
export const ACTIVATE_SIMCARDS_ERROR = 'ACTIVATE_SIMCARDS_ERROR';
// Devices
export const LINK_SIMCARD_DEVICE = 'LINK_SIMCARD_DEVICE';
export const LINK_SIMCARD_DEVICE_SUCCESS = 'LINK_SIMCARD_DEVICE_SUCCESS';
export const LINK_SIMCARD_DEVICE_ERROR = 'LINK_SIMCARD_DEVICE_ERROR';
export const UNLINK_SIMCARD_DEVICE = 'UNLINK_SIMCARD_DEVICE';
export const UNLINK_SIMCARD_DEVICE_SUCCESS = 'UNLINK_SIMCARD_DEVICE_SUCCESS';
export const UNLINK_SIMCARD_DEVICE_ERROR = 'UNLINK_SIMCARD_DEVICE_ERROR';
// Groups
export const GET_SIMCARD_GROUPS_LIST = 'GET_SIMCARD_GROUPS_LIST';
export const GET_SIMCARD_GROUPS_LIST_SUCCESS = 'GET_SIMCARD_GROUPS_LIST_SUCCESS';
export const GET_SIMCARD_GROUPS_LIST_ERROR = 'GET_SIMCARD_GROUPS_LIST_ERROR';
export const ADD_SIMCARD_GROUP = 'ADD_SIMCARD_GROUP';
export const ADD_SIMCARD_GROUP_SUCCESS = 'ADD_SIMCARD_GROUP_SUCCESS';
export const ADD_SIMCARD_GROUP_ERROR = 'ADD_SIMCARD_GROUP_ERROR';
export const GET_SIMCARD_GROUP = 'GET_SIMCARD_GROUP';
export const GET_SIMCARD_GROUP_SUCCESS = 'GET_SIMCARD_GROUP_SUCCESS';
export const GET_SIMCARD_GROUP_ERROR = 'GET_SIMCARD_GROUP_ERROR';
export const ADD_SIMCARD_GROUP_APN = 'ADD_SIMCARD_GROUP_APN';
export const ADD_SIMCARD_GROUP_APN_SUCCESS = 'ADD_SIMCARD_GROUP_APN_SUCCESS';
export const ADD_SIMCARD_GROUP_APN_ERROR = 'ADD_SIMCARD_GROUP_APN_ERROR';
export const DELETE_SIMCARD_GROUP_APN = 'DELETE_SIMCARD_GROUP_APN';
export const DELETE_SIMCARD_GROUP_APN_SUCCESS = 'DELETE_SIMCARD_GROUP_APN_SUCCESS';
export const DELETE_SIMCARD_GROUP_APN_ERROR = 'DELETE_SIMCARD_GROUP_APN_ERROR';
// APNs
export const GET_APNS_LIST = 'GET_APNS_LIST';
export const GET_APNS_LIST_SUCCESS = 'GET_APNS_LIST_SUCCESS';
export const GET_APNS_LIST_ERROR = 'GET_APNS_LIST_ERROR';
export const ADD_APN = 'ADD_APN_GROUP';
export const ADD_APN_SUCCESS = 'ADD_APN_GROUP_SUCCESS';
export const ADD_APN_ERROR = 'ADD_APN_GROUP_ERROR';

// Companies
// Main
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR';
export const ADD_COMPANY_SET_PARENT = 'ADD_COMPANY_SET_PARENT';
export const ADD_COMPANY = 'ADD_COMPANY';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_ERROR = 'ADD_COMPANY_ERROR';
export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_ERROR = 'GET_COMPANY_ERROR';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR';
export const DELETE_COMPANY = 'DELETE_COMPANY';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_ERROR = 'DELETE_COMPANY_ERROR';

// Users
// Main
export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_ERROR = 'GET_USERS_LIST_ERROR';
export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';
export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
// Profiles
// Main
export const GET_PROFILES_LIST = 'GET_PROFILES_LIST';
export const GET_PROFILES_LIST_SUCCESS = 'GET_PROFILES_LIST_SUCCESS';
export const GET_PROFILES_LIST_ERROR = 'GET_PROFILES_LIST_ERROR';
export const ADD_PROFILE = 'ADD_PROFILE';
export const ADD_PROFILE_SUCCESS = 'ADD_PROFILE_SUCCESS';
export const ADD_PROFILE_ERROR = 'ADD_PROFILE_ERROR';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const DELETE_PROFILE_SUCCESS = 'DELETE_PROFILE_SUCCESS';
export const DELETE_PROFILE_ERROR = 'DELETE_PROFILE_ERROR';
// Permissions
export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_ERROR = 'GET_PERMISSIONS_ERROR';
// Alertings
export const GET_ALERTINGS = 'GET_ALERTINGS';
export const GET_ALERTINGS_SUCCESS = 'GET_ALERTINGS_SUCCESS';
export const GET_ALERTINGS_ERROR = 'GET_ALERTINGS_ERROR';

// Production
// Device batches
export const GET_DEVICE_BATCHES = 'GET_DEVICE_BATCHES';
export const GET_DEVICE_BATCHES_SUCCESS = 'GET_DEVICE_BATCHES_SUCCESS';
export const GET_DEVICE_BATCHES_ERROR = 'GET_DEVICE_BATCHES_ERROR';
export const ADD_DEVICE_BATCH = 'ADD_DEVICE_BATCH';
export const ADD_DEVICE_BATCH_SUCCESS = 'ADD_DEVICE_BATCH_SUCCESS';
export const ADD_DEVICE_BATCH_ERROR = 'ADD_DEVICE_BATCH_ERROR';
export const GET_DEVICE_BATCH = 'GET_DEVICE_BATCH';
export const GET_DEVICE_BATCH_SUCCESS = 'GET_DEVICE_BATCH_SUCCESS';
export const GET_DEVICE_BATCH_ERROR = 'GET_DEVICE_BATCH_ERROR';
export const UPDATE_DEVICE_BATCH = 'UPDATE_DEVICE_BATCH';
export const UPDATE_DEVICE_BATCH_SUCCESS = 'UPDATE_DEVICE_BATCH_SUCCESS';
export const UPDATE_DEVICE_BATCH_ERROR = 'UPDATE_DEVICE_BATCH_ERROR';
export const GET_DEVICE_BATCH_AUTHOR = 'GET_DEVICE_BATCH_AUTHOR';
export const GET_DEVICE_BATCH_AUTHOR_SUCCESS = 'GET_DEVICE_BATCH_AUTHOR_SUCCESS';
export const GET_DEVICE_BATCH_AUTHOR_ERROR = 'GET_DEVICE_BATCH_AUTHOR_ERROR';
export const GET_DEVICE_BATCH_COMMITTER = 'GET_DEVICE_BATCH_COMMITTER';
export const GET_DEVICE_BATCH_COMMITTER_SUCCESS = 'GET_DEVICE_BATCH_COMMITTER_SUCCESS';
export const GET_DEVICE_BATCH_COMMITTER_ERROR = 'GET_DEVICE_BATCH_COMMITTER_ERROR';
export const GET_DEVICE_BATCH_DISTRIBUTION = 'GET_DEVICE_BATCH_DISTRIBUTION';
export const GET_DEVICE_BATCH_DISTRIBUTION_SUCCESS = 'GET_DEVICE_BATCH_DISTRIBUTION_SUCCESS';
export const GET_DEVICE_BATCH_DISTRIBUTION_ERROR = 'GET_DEVICE_BATCH_DISTRIBUTION_ERROR';
export const GET_DEVICE_BATCH_ARCHIVE = 'GET_DEVICE_BATCH_ARCHIVE';
export const GET_DEVICE_BATCH_ARCHIVE_SUCCESS = 'GET_DEVICE_BATCH_ARCHIVE_SUCCESS';
export const GET_DEVICE_BATCH_ARCHIVE_ERROR = 'GET_DEVICE_BATCH_ARCHIVE_ERROR';

// Updates
// Distributions
export const GET_DISTRIBUTIONS_LIST = 'GET_DISTRIBUTIONS_LIST';
export const GET_DISTRIBUTIONS_LIST_SUCCESS = 'GET_DISTRIBUTIONS_LIST_SUCCESS';
export const GET_DISTRIBUTIONS_LIST_ERROR = 'GET_DISTRIBUTIONS_LIST_ERROR';
export const ADD_DISTRIBUTION = 'ADD_DISTRIBUTION';
export const ADD_DISTRIBUTION_SUCCESS = 'ADD_DISTRIBUTION_SUCCESS';
export const ADD_DISTRIBUTION_ERROR = 'ADD_DISTRIBUTION_ERROR';
export const GET_DISTRIBUTION = 'GET_DISTRIBUTION';
export const GET_DISTRIBUTION_SUCCESS = 'GET_DISTRIBUTION_SUCCESS';
export const GET_DISTRIBUTION_ERROR = 'GET_DISTRIBUTION_ERROR';
export const UPDATE_DISTRIBUTION = 'UPDATE_DISTRIBUTION';
export const UPDATE_DISTRIBUTION_SUCCESS = 'UPDATE_DISTRIBUTION_SUCCESS';
export const UPDATE_DISTRIBUTION_ERROR = 'UPDATE_DISTRIBUTION_ERROR';
export const DELETE_DISTRIBUTION = 'DELETE_DISTRIBUTION';
export const DELETE_DISTRIBUTION_SUCCESS = 'DELETE_DISTRIBUTION_SUCCESS';
export const DELETE_DISTRIBUTION_ERROR = 'DELETE_DISTRIBUTION_ERROR';
export const GET_DISTRIBUTION_ARCHIVE = 'GET_DISTRIBUTION_ARCHIVE';
export const GET_DISTRIBUTION_ARCHIVE_SUCCESS = 'GET_DISTRIBUTION_ARCHIVE_SUCCESS';
export const GET_DISTRIBUTION_ARCHIVE_ERROR = 'GET_DISTRIBUTION_ARCHIVE_ERROR';
// Rollouts
export const GET_ROLLOUTS_LIST = 'GET_ROLLOUTS_LIST';
export const GET_ROLLOUTS_LIST_SUCCESS = 'GET_ROLLOUTS_LIST_SUCCESS';
export const GET_ROLLOUTS_LIST_ERROR = 'GET_ROLLOUTS_LIST_ERROR';
export const ADD_ROLLOUT = 'ADD_ROLLOUT';
export const ADD_ROLLOUT_SUCCESS = 'ADD_ROLLOUT_SUCCESS';
export const ADD_ROLLOUT_ERROR = 'ADD_ROLLOUT_ERROR';
export const GET_ROLLOUT = 'GET_ROLLOUT';
export const GET_ROLLOUT_SUCCESS = 'GET_ROLLOUT_SUCCESS';
export const GET_ROLLOUT_ERROR = 'GET_ROLLOUT_ERROR';
export const DELETE_ROLLOUT = 'DELETE_ROLLOUT';
export const DELETE_ROLLOUT_SUCCESS = 'DELETE_ROLLOUT_SUCCESS';
export const DELETE_ROLLOUT_ERROR = 'DELETE_ROLLOUT_ERROR';
export const GET_ROLLOUT_DEVICES_LIST = 'GET_ROLLOUT_DEVICES_LIST';
export const GET_ROLLOUT_DEVICES_LIST_SUCCESS = 'GET_ROLLOUT_DEVICES_LIST_SUCCESS';
export const GET_ROLLOUT_DEVICES_LIST_ERROR = 'GET_ROLLOUT_DEVICES_LIST_ERROR';

// From themes
export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_NAV_BEHIND = 'TOGGLE_NAV_BEHIND';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';

// ---------------------------------------------------------- //
// --------------- Car park management actions -------------- //
// ---------------------------------------------------------- //

// Operations
export const CPM_REGISTER_OPERATION = 'CPM_REGISTER_OPERATION';
export const CPM_PURGE_OPERATIONS = 'CPM_PURGE_OPERATIONS';
export const CPM_UPDATE_STATUS_OPERATIONS = 'CPM_UPDATE_STATUS_OPERATIONS';

// Events
export const CPM_UPDATE_EVENT_STATUS = 'CPM_UPDATE_EVENT_STATUS';

// Registrations
export const CPM_REGISTER_CARPARK_TRIGGER = 'CPM_REGISTER_CARPARK_TRIGGER';

// AutoComplete
export const CPM_GET_CARPARKS_AUTOCOMPLETE = 'CPM_GET_CARPARKS_AUTOCOMPLETE';
export const CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE = 'CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE';
export const CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE = 'CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE';

// List filters
export const CPM_GET_CARPARK_CUSTOMER_LF = 'CPM_GET_CARPARK_CUSTOMER_LF';
export const CPM_GET_CARPARK_PARKING_LF = 'CPM_GET_CARPARK_PARKING_LF';

// Price rules
export const CPM_GET_PRICE_RULES = 'CPM_GET_PRICE_RULES';

// Car parks
// Me
export const CPM_DELETE_MY_PAYMENT_METHOD = 'CPM_DELETE_MY_PAYMENT_METHOD';

// Cache
export const CPM_RESET_CARPARK_CACHE = 'CPM_RESET_CARPARK_CACHE';
// Main
export const CPM_GET_CARPARKS_LIST = 'CPM_GET_CARPARKS_LIST';
export const CPM_COUNT_CARPARKS = 'CPM_COUNT_CARPARKS';
export const CPM_GET_CARPARK = 'CPM_GET_CARPARK';
export const CPM_GET_CARPARK_BY_SLUG = 'CPM_GET_CARPARK_BY_SLUG';
export const CPM_GET_CARPARK_DEFAULT_SLUG = 'CPM_GET_CARPARK_DEFAULT_SLUG';
export const CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES = 'CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES';
export const CPM_UPDATE_CARPARK = 'CPM_UPDATE_CARPARK';
export const CPM_UPDATE_CARPARK_CONTACT = 'CPM_UPDATE_CARPARK_CONTACT';
export const CPM_TRIGGER_CARPARK_DOOR = 'CPM_TRIGGER_CARPARK_DOOR';
export const CPM_GET_CARPARK_UNIQUE_KEYPAD_CODE = 'CPM_GET_CARPARK_UNIQUE_KEYPAD_CODE';
export const CPM_GET_CARPARK_REVENUES_SUMMARY = 'CPM_GET_CARPARK_REVENUES_SUMMARY';
export const CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS = 'CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS';
export const CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS = 'CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS';
export const CPM_UPDATE_CARPARK_GENERAL_SETTINGS = 'CPM_UPDATE_CARPARK_GENERAL_SETTINGS';
export const CPM_UPDATE_CARPARK_BOOKING_SETTINGS = 'CPM_UPDATE_CARPARK_BOOKING_SETTINGS';
export const CPM_UPDATE_CARPARK_SPACES_SETTINGS = 'CPM_UPDATE_CARPARK_SPACES_SETTINGS';
export const CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION = 'CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION';
export const CPM_UPDATE_CARPARK_PARTNER = 'CPM_UPDATE_CARPARK_PARTNER';
// Activity
export const CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST = 'CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST';
export const CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST = 'CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST';
export const CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST = 'CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST';
export const CPM_GET_CARPARK_ACTIVITY_EXITS_LIST = 'CPM_GET_CARPARK_ACTIVITY_EXITS_LIST';
// Plannings
export const CPM_GET_CARPARK_PLANNINGS = 'CPM_GET_CARPARK_PLANNINGS';
export const CPM_GET_CARPARK_PLANNING = 'CPM_GET_CARPARK_PLANNING';
export const CPM_ADD_CARPARK_PLANNING = 'CPM_ADD_CARPARK_PLANNING';
export const CPM_UPDATE_CARPARK_PLANNING = 'CPM_UPDATE_CARPARK_PLANNING';
export const CPM_DELETE_CARPARK_PLANNING = 'CPM_DELETE_CARPARK_PLANNING';
// Parking categories
export const CPM_GET_CARPARK_PARKING_CATEGORIES = 'CPM_GET_CARPARK_PARKING_CATEGORIES';
export const CPM_ADD_CARPARK_PARKING_CATEGORY = 'CPM_ADD_CARPARK_PARKING_CATEGORY';
export const CPM_UPDATE_CARPARK_PARKING_CATEGORY = 'CPM_UPDATE_CARPARK_PARKING_CATEGORY';
export const CPM_DELETE_CARPARK_PARKING_CATEGORY = 'CPM_DELETE_CARPARK_PARKING_CATEGORY';
export const CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY = 'CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY';
export const CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY = 'CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY';
export const CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER = 'CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER';
// Price grids
export const CPM_GET_CARPARK_PRICE_GRIDS = 'CPM_GET_CARPARK_PRICE_GRIDS';
export const CPM_ADD_CARPARK_PRICE_GRID = 'CPM_ADD_CARPARK_PRICE_GRID';
export const CPM_UPDATE_CARPARK_PRICE_GRID = 'CPM_UPDATE_CARPARK_PRICE_GRID';
// Customers
export const CPM_GET_CARPARK_CUSTOMERS_LIST = 'CPM_GET_CARPARK_CUSTOMERS_LIST';
export const CPM_GET_CARPARK_CUSTOMER = 'CPM_GET_CARPARK_CUSTOMER';
export const CPM_ADD_CARPARK_CUSTOMER = 'CPM_ADD_CARPARK_CUSTOMER';
export const CPM_UPDATE_CARPARK_CUSTOMER = 'CPM_UPDATE_CARPARK_CUSTOMER';
export const CPM_DELETE_CARPARK_CUSTOMER = 'CPM_DELETE_CARPARK_CUSTOMER';
export const CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT = 'CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT';
export const CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT = 'CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT';
export const CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST = 'CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST';
export const CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST = 'CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST';
export const CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST = 'CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST';
export const CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST = 'CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST';
// Parkings
export const CPM_GET_CARPARK_PARKINGS_LIST = 'CPM_GET_CARPARK_PARKINGS_LIST';
export const CPM_ADD_CARPARK_PARKING = 'CPM_ADD_CARPARK_PARKING';
export const CPM_UPDATE_CARPARK_PARKING = 'CPM_UPDATE_CARPARK_PARKING';
export const CPM_UPDATE_CARPARK_PARKING_STATE = 'CPM_UPDATE_CARPARK_PARKING_STATE';
export const CPM_DELETE_CARPARK_PARKING = 'CPM_DELETE_CARPARK_PARKING';
export const CPM_GET_CARPARK_PARKING_ACCESSES_LIST = 'CPM_GET_CARPARK_PARKING_ACCESSES_LIST';
// On demand
export const CPM_GET_CARPARK_ON_DEMAND_LIST = 'CPM_GET_CARPARK_ON_DEMAND_LIST';
export const CPM_CATEGORIZE_CARPARK_ON_DEMAND = 'CPM_CATEGORIZE_CARPARK_ON_DEMAND';
export const CPM_DELETE_CARPARK_ON_DEMAND = 'CPM_DELETE_CARPARK_ON_DEMAND';
export const CPM_GET_ON_DEMAND_ACCESS = 'CPM_GET_ON_DEMAND_ACCESS';
export const CPM_SEARCH_ON_DEMAND_ACCESS = 'CPM_SEARCH_ON_DEMAND_ACCESS';
export const CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS = 'CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS';
export const CPM_EXTEND_ON_DEMAND_ACCESS = 'CPM_EXTEND_ON_DEMAND_ACCESS';
export const CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY = 'CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY';
export const CPM_CREATE_ON_DEMAND_ACCESS = 'CPM_CREATE_ON_DEMAND_ACCESS';
export const CPM_TERMINATE_ON_DEMAND_ACCESS = 'CPM_TERMINATE_ON_DEMAND_ACCESS';
export const CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER = 'CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER';
export const CPM_UPDATE_ON_DEMAND_ACCESS = 'CPM_UPDATE_ON_DEMAND_ACCESS';
export const CPM_REFUND_ON_DEMAND_ACCESS = 'CPM_REFUND_ON_DEMAND_ACCESS';
export const CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE = 'CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE';
export const CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS = 'CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS';
// Purchase
export const CPM_REFUND_PURCHASE = 'CPM_REFUND_PURCHASE';
// Accesses
export const CPM_GET_CARPARK_ACCESSES_LIST = 'CPM_GET_CARPARK_ACCESSES_LIST';
// Metrics
export const CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE = 'CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE';
export const CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD = 'CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD';
export const CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED = 'CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED';
export const CPM_GET_CARPARK_METRICS_ACCESSES = 'CPM_GET_CARPARK_METRICS_ACCESSES';
export const CPM_GET_CARPARK_METRICS_REVENUES = 'CPM_GET_CARPARK_METRICS_REVENUES';
export const CPM_GET_CARPARK_METRICS_REVENUES_REPORT = 'CPM_GET_CARPARK_METRICS_REVENUES_REPORT';
// Bookings - Parkings
export const CPM_GET_CARPARK_BOOKINGS_LIST = 'CPM_GET_CARPARK_BOOKINGS_LIST';
export const CPM_SEARCH_CARPARK_BOOKING_OFFER = 'CPM_SEARCH_CARPARK_BOOKING_OFFER';
export const CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER = 'CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER';
export const CPM_ADD_CARPARK_BOOKING = 'CPM_ADD_CARPARK_BOOKING';
export const CPM_CANCEL_CARPARK_BOOKING = 'CPM_CANCEL_CARPARK_BOOKING';
export const CPM_UPDATE_CARPARK_BOOKING = 'CPM_UPDATE_CARPARK_BOOKING';
export const CPM_UPDATE_CARPARK_BOOKING_STATE = 'CPM_UPDATE_CARPARK_BOOKING_STATE';
export const CPM_SEND_BOOKING_PAYMENT_LINK = 'CPM_SEND_BOOKING_PAYMENT_LINK';
export const CPM_REFUND_BOOKING = 'CPM_REFUND_BOOKING';
export const CPM_RESEND_BOOKING_CONFIRMATION_EMAIL = 'CPM_RESEND_BOOKING_CONFIRMATION_EMAIL';
export const CPM_DECLARE_FINAL_EXIT_FOR_BOOKING = 'CPM_DECLARE_FINAL_EXIT_FOR_BOOKING';
// My Booking
export const CPM_LIST_MY_CARPARK_BOOKING_OPTIONS = 'CPM_LIST_MY_CARPARK_BOOKING_OPTIONS';
export const CPM_BOOK_CARPARK = 'CPM_BOOK_CARPARK';
export const CPM_EXTEND_BOOK_CARPARK = 'CPM_EXTEND_BOOK_CARPARK';
export const CPM_PAY_BOOKING_OVERSTAY = 'CPM_PAY_BOOKING_OVERSTAY';
export const CPM_GET_MY_BOOKINGS_LIST = 'CPM_GET_MY_BOOKINGS_LIST';
export const CPM_CANCEL_MY_BOOKING = 'CPM_CANCEL_MY_BOOKING';
export const CPM_GET_MY_BOOKING = 'CPM_GET_MY_BOOKING';
export const CPM_GET_UPDATED_MY_BOOKING = 'CPM_GET_UPDATED_MY_BOOKING';
export const CPM_GET_OFFER = 'CPM_GET_OFFER';
// Onepark booking
export const CPM_GET_ONEPARK_BOOKINGS_LIST = 'CPM_GET_ONEPARK_BOOKINGS_LIST';
// Sidebar
export const CPM_TOGGLE_SIDEBAR = 'CPM_TOGGLE_SIDEBAR';
// Accounts
export const CPM_GET_ACCOUNTS_LIST = 'CPM_GET_ACCOUNTS_LIST';
export const CPM_SIGN_UP = 'CPM_SIGN_UP';
export const CPM_SET_ACCOUNT_STATUS = 'CPM_SET_ACCOUNT_STATUS';
export const CPM_CHECK_CUSTOMER_ACCOUNT_LINK = 'CPM_CHECK_CUSTOMER_ACCOUNT_LINK';
export const CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK = 'CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK';
export const CPM_VALIDATE_ACCOUNT_LINK = 'CPM_VALIDATE_ACCOUNT_LINK';
// Invoices
export const CPM_GET_CARPARK_INVOICES_LIST = 'CPM_GET_CARPARK_INVOICES_LIST';
export const CPM_DOWNLOAD_CARPARK_INVOICE = 'CPM_DOWNLOAD_CARPARK_INVOICE';
export const CPM_DOWNLOAD_CARPARK_INVOICES = 'CPM_DOWNLOAD_CARPARK_INVOICES';
export const CPM_DOWNLOAD_MY_INVOICE = 'CPM_DOWNLOAD_MY_INVOICE';
export const CPM_UPDATE_CARPARK_INVOICE = 'CPM_UPDATE_CARPARK_INVOICE';
export const CPM_RESET_CARPARK_INVOICE_DOWNLOAD_REQUEST = 'CPM_RESET_CARPARK_INVOICE_DOWNLOAD_REQUEST';
export const CPM_RESET_MY_INVOICE_DOWNLOAD_REQUEST = 'CPM_RESET_MY_INVOICE_DOWNLOAD_REQUEST';
// Partners
export const CPM_GET_PARTNERS_LIST = 'CPM_GET_PARTNERS_LIST';
export const CPM_CREATE_PARTNER = 'CPM_CREATE_PARTNER';
export const CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION = 'CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION';
// Workspace
export const CPM_LIST_WORKSPACES = 'CPM_LIST_WORKSPACES';
export const CPM_GET_WORKSPACE = 'CPM_GET_WORKSPACE';
export const CPM_CREATE_WORKSPACE = 'CPM_CREATE_WORKSPACE';
export const CPM_UPDATE_WORKSPACE = 'CPM_UPDATE_WORKSPACE';
// Workspace Group
export const CPM_LIST_WORKSPACE_GROUPS = 'CPM_LIST_WORKSPACE_GROUPS';
export const CPM_GET_WORKSPACE_GROUP = 'CPM_GET_WORKSPACE_GROUP';
export const CPM_CREATE_WORKSPACE_GROUP = 'CPM_CREATE_WORKSPACE_GROUP';
export const CPM_UPDATE_WORKSPACE_GROUP = 'CPM_UPDATE_WORKSPACE_GROUP';
export const CPM_UPDATE_CARPARK_WORKSPACE_GROUPS = 'CPM_UPDATE_CARPARK_WORKSPACE_GROUPS';
export const CPM_GET_CARPARK_WORKSPACE_GROUPS = 'CPM_GET_CARPARK_WORKSPACE_GROUPS';

// Service fee rules
export const CPM_GET_SERVICE_FEE_RULE = 'CPM_GET_SERVICE_FEE_RULE';
export const CPM_LIST_SERVICE_FEE_RULES = 'CPM_LIST_SERVICE_FEE_RULES';
export const CPM_CREATE_SERVICE_FEE_RULE = 'CPM_CREATE_SERVICE_FEE_RULE';
export const CPM_DELETE_SERVICE_FEE_RULE = 'CPM_DELETE_SERVICE_FEE_RULE';
export const CPM_UPDATE_SERVICE_FEE_RULE = 'CPM_UPDATE_SERVICE_FEE_RULE';

// Slugs
export const CPM_LIST_SLUGS = 'CPM_LIST_SLUGS';
export const CPM_GET_SLUG_BY_DOMAIN = 'CPM_GET_SLUG_BY_DOMAIN';
export const CPM_CREATE_SLUG = 'CPM_CREATE_SLUG';
export const CPM_DELETE_SLUG = 'CPM_DELETE_SLUG';
export const CPM_UPDATE_SLUG = 'CPM_UPDATE_SLUG';

export const CPM_INITIATE_PAYMENT = 'CPM_INITIATE_PAYMENT';



// WEBPACK FOOTER //
// ./constants/ActionTypes.js